import type { SearchInput } from '#graphql-operations'

export async function searchStore(input: SearchInput) {
  const { data, errors } = await useGraphqlQuery('searchStore', {
    input,
    collectionsInput: {
      take: input.take,
      skip: input.skip,
      term: input.term,
    },
  })

  if (errors?.length)
    console.error('GraphQL errors:', errors)

  return data
}
